<template>
    <CompassTable class="table-loading" :size="size">
        <CompassTableHead class="table-loading__head">
            <CompassTableHeadCell
                v-for="(col, index) in resolvedColumns"
                :id="`loading-col-${index}`"
                :key="index"
                :defaultWidth="col.width"
                :fitContent="col.fitContent"
            />
        </CompassTableHead>
        <CompassTableBody>
            <CompassTableRow v-for="row in rowCount" :key="row">
                <CompassTableBodyCell
                    v-for="(col, index) in resolvedColumns"
                    :key="index"
                    :idColumn="`loading-col-${index}`"
                >
                    <CompassSkeleton :variant="col.skeleton" :size="col.skeletonSize" />
                </CompassTableBodyCell>
            </CompassTableRow>
        </CompassTableBody>
    </CompassTable>
</template>
<script setup lang="ts">
import { computed } from 'vue';

type SkeletonVariantType = typeof CompassEnums.SkeletonVariantType;
type SkeletonSizeType = typeof CompassEnums.SkeletonSize;
type TableSizeType = typeof CompassEnums.TableSize;

interface TableLoadingColumn {
    width?: number;
    skeleton?: SkeletonVariantType[keyof SkeletonVariantType];
    skeletonSize?: SkeletonSizeType[keyof SkeletonSizeType];
    fitContent?: boolean;
}

const props = withDefaults(
    defineProps<{
        columns?: TableLoadingColumn[];
        rowCount?: number;
        size?: TableSizeType[keyof TableSizeType];
    }>(),
    {
        columns: undefined,
        rowCount: 10,
        size: undefined,
    },
);

const resolvedColumns = computed<TableLoadingColumn[]>(() => {
    if (props.columns) {
        return props.columns;
    }

    const medium = props.size === CompassEnums.TableSize.MEDIUM;
    const { SkeletonSize } = CompassEnums;
    const size = medium ? SkeletonSize.MEDIUM : SkeletonSize.LARGE;

    return [{ skeletonSize: size }];
});
</script>
<style lang="scss" scoped>
.table-loading {
    &__head {
        display: none;
    }
    :deep() {
        .compass-table__cell-container {
            width: 100%;
        }
        .compass-table-body__cell .compass-skeleton:has(.compass-skeleton__line) {
            width: 100%;
        }
        .compass-table-body__row:hover > .compass-table__cell {
            background-color: var(--colors-common-background-default);
        }
    }
}
</style>
